import AnswerKeyWord from "./AnswerKeyWord";
import React from "react";

class WriteMissingWordsContainerModel {
    constructor() {
        this.writeMissingWordsId = 0
        this.paragraph = ""
        this.answerList = [] // array of AnswerKeyWord
        this.styleIndex = 0;
        // this.initStyleArr()
        this.selectedStyle = []//this.styleArr[this.styleIndex]

    }
    getReviewColor = (index) => {
        let ansTxt = this.answerList[index].solvedAnswer 

       // this.answerList[index].forEach(element => {
            let rightAns = this.answerList[index].answers.filter(function (answer, index) {
                return answer == ansTxt
            })
            if (rightAns.length > 0)
                return "green"
            else
                return "red"
      //  });
    }
    getAsJson = () => {
        let obj = {}
        obj.paragraph = this.paragraph
        //obj.styleIndex = this.styleIndex
        obj.selectedStyle = this.selectedStyle
        obj.answerList = [];
        for (let i = 0; i < this.answerList.length; i++) {
            obj.answerList.push(this.answerList[i].getAsJson());
        }

        // window.projectPlugin.onGetAsJson(obj)

        return obj
    }


    initFromJson = (obj) => {
        this.paragraph = obj.paragraph
        // this.styleIndex = obj.styleIndex
        this.selectedStyle = obj.selectedStyle
        //this.replaceToInput()
        for (let i = 0; i < obj.answerList.length; i++) {
            let answerKeyWord = new AnswerKeyWord()
            answerKeyWord.initFromJson(obj.answerList[i])
            this.answerList.push(answerKeyWord);
        }
    }
    // initStyleArr = () => {

    //     this.styleArr = window.selectedStyle.writeMissingWordsStyle.txtContainer

    // }

    addAnswer = (answer) => {
        answer.answerIndex = this.answerList.length
        answer.answer = answer.answerIndex + 1
        answer.isSensitive = false
        answer.answers = []
        this.answerList.push(answer)
    }

    removeAnswer = (answerIndex) => {
        this.answerList.splice(answerIndex, 1)

        for (let i = 0; i < this.answerList.length; i++) {
            this.answerList[i].answerIndex = i
        }
    }
    initFromJsonTest4You = (obj) => {
        this.paragraph = obj.paragraph
        let answerList = JSON.parse(obj.answerList)
        for (var key of Object.keys(answerList)) {
            let answerKeyWord = new AnswerKeyWord();
            
            answerKeyWord.answerIndex =parseInt(key) -1 ;
            answerKeyWord.isSensitive = answerList[key]
            answerKeyWord.answers = []
            for (var ansKey of Object.keys(answerList[key])) {
                let Case = answerList[key][ansKey].Case
                let Option = answerList[key][ansKey].Option

                answerKeyWord.isSensitive = Case == 'Y' ? true : false
                answerKeyWord.answers.push(Option) 
            }

            this.answerList.push(answerKeyWord)
        }
    }
    // nextStyle = () => {

    //     if (this.styleIndex < this.styleArr.length - 1) {
    //         this.styleIndex++;
    //         this.selectedStyle = this.styleArr[this.styleIndex]
    //     }
    // }

    // prevStyle = () => {
    //     if (this.styleIndex > 0) {
    //         this.styleIndex--;
    //         this.selectedStyle = this.styleArr[this.styleIndex]
    //     }
    // }
}
export default WriteMissingWordsContainerModel